import { gql } from "@apollo/client";

export const GENERATE_EOC_HISTORY = gql`
  query GetEocHistory($cId: ID!, $pId: ID!) {
    getEocHistory(cId: $cId, pId: $pId) {
      fileName
      size
      lastModified
    }
  }
`;
